$(document).on("turbolinks:load", function () {
  if ( $('.js-edit-credit-input').is('*') ){

    $('.js-edit-credit-input').on('change keyup', function(){
      var collectionKey = $(this).data('collection');
      var changeValue = $(this).val();

      if (collectionKey) {
        $('body').find('input[data-collection=' + collectionKey + '].js-edit-credit-input').val(changeValue);
      }
    });

    $('.js-edit-credit-expiration').on('change', function(){
      var collectionKey = $(this).data('collection');
      var changeValue = $(this).val();

      if (collectionKey) {
        $('body').find('input[data-collection=' + collectionKey + '].js-edit-credit-expiration').val(changeValue);
      }
    });
  }
});